import React, { useState } from 'react'

const ErrorContext = React.createContext(null)
export default ErrorContext

export function useErrors(){

    const [ messages, setMessages ] = useState([])

    function addMessage(message, details, url, statusCode, requestId) {
        const messageString = (typeof message === "string") ? message : JSON.stringify(message)
        const detailsString = (typeof details === "string") ? details : JSON.stringify(details)
        const maxMessages = 2
        setMessages((previous) => [...(previous.filter(
            e => (e.message !== messageString && e.details !== detailsString))
            .slice(maxMessages * -1)), {
            message : messageString,
            details : detailsString,
            url : url,
            statusCode: statusCode,
            requestId: requestId,
            ts: (new Date()).getTime()
        }])
    }

    function clearMessages() {
        setMessages([])
    }

    function pruneOldMessages() {
        const now = (new Date()).getTime();
        const retentionTimeMs = 60 * 1000;
        if (messages.length > 0) {
            setMessages((previous) => [...(previous.filter(m => m.ts + retentionTimeMs > now))])
        }
    }

    const errorState = {
        messages,
        addMessage,
        clearMessages,
        pruneOldMessages
    }

    return errorState
}
